import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormFieldsService } from '@shared/shared/services/form-fields.service';
import { FormFieldAbstractComponent } from '../abstract.component';
import { provideTranslation } from '@skyeng/libs/shared/i18n';
import { TeacherSelectionUnavailableSlots } from '../../../../../teachers-schedule/person/types';

@Component({
  selector: 'crm-form-field-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideTranslation('formFieldSchedule', () => import.meta.webpackContext!('./translation'))],
})
export class FormFieldScheduleComponent extends FormFieldAbstractComponent {
  @Input() minutesStep: number;
  @Input() teacherSelectionUnavailableSlots: TeacherSelectionUnavailableSlots;

  constructor(protected formFieldsService: FormFieldsService) {
    super(formFieldsService);
  }
}
